import React, { useEffect, useState, useLayoutEffect } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import From from '../CreateTimetable/components/From/From';
import { get_showroom_agencies, get_showroom_details } from '../../api/API';

const useStyles = makeStyles(theme => ({
    root: {
        padding: '24px',
    },

}));

export default class CreateTimetable extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            property_id: props.match.params.id,
            agencies: null,
            property: null
        };
        console.log(props);
    }

    async get_property() {
        var data = await get_showroom_details(this.state.property_id);
        if (data) {
            this.setState({
                ...this.state,
                property: data
            });
        } else {
            console.log(data);
        }
    }

    async get_agencies() {
        var data = await get_showroom_agencies(this.state.property_id);
        if (data) {
            this.setState({
                ...this.state,
                agencies: data
            });
        } else {
            console.log(data);
        }
    }

    async componentWillMount() {
        this.get_agencies();
        this.get_property();
    }

    render() {
        return (
            <div className={clsx(this.props.classes.root, this.props.className)} >
                {this.state.property && this.state.agencies != null && (
                    <From
                        is_special={this.props.is_special}
                        showroom_id={this.state.property_id}
                        showroom_agencies={this.state.agencies}
                        max_pax={this.state.property.max_pax}
                        max_appointment={this.state.property.max_appointment}
                    />
                )}

            </div>
        )
    }

}
